/* eslint-disable @next/next/no-img-element */

import Link from 'next/link'
import { classNames } from 'util/classNames'
const ToastyLogo = ({
  className = '',
  href = '/',
  color = 'black',
}: {
  className?: string
  href?: string
  color?: 'white' | 'black'
}) => {
  return (
    <Link
      href={href}
      className={classNames('cursor-pointer text-white md:mb-0', className)}
    >
      {color === 'black' ? (
        <img
          className={classNames('h-[16px] w-[100px] text-white', className)}
          src="/outcast-black.png"
          alt="Outcast Logo"
        />
      ) : (
        <img
          className={classNames('h-[16px] w-[100px] text-white', className)}
          src="/outcast-white.png"
          alt="Outcast Logo"
        />
      )}
    </Link>
  )
}

export default ToastyLogo
